import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, FormHelperText,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMatStkValue } from '../../Store/PHPSlice/MatInward';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { createMatOutwardEntry } from '../../Store/PHPSlice/MatOutward';
import { selectMaterials, selectEmployees, selectMatInwardData } from '../Selectors/Master/OutwardSelectors';
import { errorStyles } from '../../Utils/table';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const MaterialOutwardEntry2 = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: '',
        empId: ' ',
        materialNm: ' ',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const materials = useSelector(selectMaterials);
    const employees = useSelector(selectEmployees);
    const stk_value = useSelector(selectMatInwardData);

    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        empId: fetchEmployeeData
        // Add more mappings if needed
    };

    useEffect(() => {
        dispatch(fetchMaterialData());
        dispatch(fetchEmployeeData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    // const handleAddMaterial = () => {
    //     const selectedMaterial = materials.data.find(item => item.ID === formData.materialNm);
    //     const mateId = selectedMaterial.ID;

    //     if (selectedMaterial) {
    //         setTableRows([
    //             ...tableRows,
    //             {
    //                 id: tableRows.length + 1,
    //                 materialId: selectedMaterial.ID,
    //                 materialNm: selectedMaterial.materialNm,
    //                 description: selectedMaterial.description || '',
    //                 size: selectedMaterial.size || '',
    //                 packets: selectedMaterial.packets || '',
    //                 qty: selectedMaterial.qty,
    //             }
    //         ]);

    //         dispatch(fetchMatStkValue(mateId));
    //     }
    //     console.log("qty=>",selectedMaterial.qty);
    //     setFormData({
    //         ...formData,
    //         materialNm: ''
    //     })
    // };
    // ✅ Corrected function to fetch and add material with stock qty
    const handleAddMaterial = () => {
        const selectedMaterial = materials?.data2?.find(item => item.ID === formData.materialNm);
        const mateId = selectedMaterial?.ID;

        if (!selectedMaterial) {
            alert("Please select a material first!");
            return;
        }

        dispatch(fetchMatStkValue(mateId))
            .unwrap()
            .then((res) => {
                const inwardQty = res.data?.[0]?.inwardqty ?? 0;
                const packetQty = res.data?.[0]?.packetqty ?? 0;
                const totalQty = res.data?.[0]?.totqty ?? 0;
                const pkt = res.data?.[0]?.pkt ?? 0;
                const looseqty = res?.data?.[0]?.looseqty ?? 0;

                // console.log(selectedMaterial?.packets, 'stk', pkt);

                const concatqty = `${pkt}(Loose - ${looseqty})`;
                setTableRows((prevRows) => [
                    ...prevRows,
                    {
                        id: prevRows.length + 1,
                        materialId: selectedMaterial?.ID,
                        materialNm: selectedMaterial?.materialNm,
                        description: selectedMaterial?.description || '',
                        size: selectedMaterial?.size || '',
                        packets: pkt || '',
                        concatqty: concatqty,
                        packetqty: packetQty,
                        inwardqty: inwardQty, // ✅ this will now show proper inward qty
                        totqty: totalQty,
                        updatePktQty: '',
                        updatepktqty: "",
                        updatelooseqty: '',
                        qty: '' // outward qty left empty
                    }
                ]);
            })
            .catch((err) => {
                console.error('Error fetching stock value:', err);
            });

        setFormData({
            ...formData,
            materialNm: ''
        });
    };


    const handleInputChange = (index, field, value) => {
        const val = stk_value.data.length > 0 ? stk_value.data[0].qty : 0; // Default to 0 if singelMatInward.data is not yet populated
        let newValue = value;

        if (field === 'qty' && parseInt(value, 10) > val) {
            alert(`Value cannot be greater than ${val}`);
            newValue = ''; // Reset the field to empty string
        }

        const updatedRows = tableRows.map((row, i) => {
            if (i === index) {
                return { ...row, [field]: newValue.toUpperCase() };
            }
            return row;
        });

        setTableRows(updatedRows);
    };

    const handleCheckboxChange = (rowId) => {
        if (selectedRows.includes(rowId)) {
            setSelectedRows(selectedRows.filter(id => id !== rowId));
        } else {
            setSelectedRows([...selectedRows, rowId]);
        }
    };

    const handleDeleteMaterial = () => {
        setTableRows(tableRows.filter(row => !selectedRows.includes(row.id)));
        setSelectedRows([]);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.empId) newErrors.empId = 'Employee Name is required';
        // if (!formData.materialNm) newErrors.materialNm = 'Material Name is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        if (tableRows.length > 0) {
            var finalObject = {
                dt: formData.dt,
                empId: formData.empId,
                tableRows: tableRows,
                userId: formData.userId
            };

            setLoading(true);

            try {
                const result = await dispatch(createMatOutwardEntry(finalObject)).unwrap();
                console.log('POST request successful!', result);
                alert("Material Outward Added");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }


        } else {
            alert("Select Employee & Material & Enter table details");
        }
    };


    const handleItemNew = () => {
        window.open(`/new-employee-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlist = [
        {
            label: 'Employee',
            id: 'empId',
            options: employees?.data || [],
            value: formData.empId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleItemNew(),
            btnlabel: 'Add',
            handleDropdownOpen: () => handleDropdownOpen('empId'),
            handleDropdownClose: () => handleDropdownClose('empId'),
            errors: errors.empId
        },
        {
            label: 'Material',
            id: 'materialNm',
            options: materials?.data2 || [],
            value: formData.materialNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'materialNm', value: newValue ? newValue.ID : '' } }, 'materialNm'),
            getOptionLabel: (option) => `${option.materialNm}-${option.size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            // handleAddNew: () => handleItemNew(),
            // btnlabel: 'Add',
            // handleDropdownOpen: () => handleDropdownOpen('materialNm'),
            // handleDropdownClose: () => handleDropdownClose('materialNm'),
            errors: errors.materialNm
        },
    ];


    const handleQtyChanges = (e, index) => {
        const { name, value } = e.target;

        const newValue = Number(value);
        const tables = [...tableRows];

        const maxQtyAllowed = Number(tables[index]?.totqty);
        const pktperqty = Number(tables[index]?.packets);
        const pktqty = Number(tables[index]?.packetqty);
        const inwardqty = Number(tables[index]?.inwardqty);

        if (newValue > maxQtyAllowed) {
            tables[index].qty = maxQtyAllowed;
        } else if (newValue < 0) {
            tables[index].qty = 0;
        } else {
            tables[index].qty = newValue;

            const updatedqty = inwardqty - newValue;
            const updatedpkts = Math.floor(updatedqty / pktperqty);
            const correctPktsqty = updatedpkts * pktperqty;
            const looseqty = updatedqty - correctPktsqty;
            tables[index].updatePktQty = `${updatedpkts} (Loose - ${looseqty})`;
            tables[index].updatelooseqty = looseqty;
            tables[index].updatepktqty = updatedpkts;
        }

        setTableRows(tables);

    }

    return (
        <>
            <Titlebar data={MaterialMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Outward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>



                                {dropdownlist?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        errors={drop.errors}
                                        handleDropdownClose={drop.handleDropdownClose}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                    />
                                ))
                                }

                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddMaterial} sx={{ mr: 2 }}>Add</Button>
                                    <Button variant="contained" color="primary" onClick={handleDeleteMaterial}>Delete</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ marginTop: '1%' }}>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Material Name</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Description</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Per Packet Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'> Packet Qty</TableCell>

                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Stock Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Outward Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Bal. Packet Qty</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows?.map((row, index) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(row.id)}
                                                                    onChange={() => handleCheckboxChange(row.id)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{row.id}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.materialNm}

                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.description}

                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.size}

                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* {row.packets} */}
                                                                {row.concatqty}

                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.packetqty}

                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.totqty}

                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <input
                                                                    type="text"
                                                                    value={row.qty}
                                                                    name='qty'
                                                                    onChange={(e) => handleQtyChanges(e, index)}
                                                                    style={{ width: '100px', outline: 'none' }}
                                                                />

                                                            </TableCell>

                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.updatePktQty}

                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MaterialOutwardEntry2;
